<template>
  <emd-card>
    <emd-card-header class="eu-justify_between">
      <div class="eu-flex eu-justify_center eu-align_center eu-px_2">
        <emd-text size="section"> {{ $t('header') }}: </emd-text>
        <emd-text size="text"> &nbsp; {{ data.id }} </emd-text>
      </div>
      <slot name="actions"></slot>
    </emd-card-header>
    <emd-card-content customClass="eu-no-padding">
      <table-links
        :fields="fields"
        :items="[data]"
      />
    </emd-card-content>
    <slot name="modal" />
  </emd-card>
</template>

<script>
import {
  EmdText,
  EmdCard,
  EmdCardHeader,
  EmdCardContent
} from 'emerald-vue/src/components'

import { FIELDS_DETAIL } from '../../enums/payment-links-fields.enum'

import TableLinks from '../../components/TableLinks.vue'

export default {
  name: 'GeneralInfoLink',
  components: {
    EmdText,
    EmdCard,
    EmdCardHeader,
    EmdCardContent,
    TableLinks
  },
  props: {
    data: Object
  },
  data () {
    return {
      isModalOpen: false,
      fields: FIELDS_DETAIL
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "header": "Link de pagamento"
    },
    "en-US": {
      "header": "Payment Link"
    }
  }
</i18n>
